<template>
  <div>
    <v-row class="tabs-demo__size">
      <v-col :span="22">
        <v-tabs
          v-model="activeNamebutton"
          size="S"
          name="tabs-s-card"
          type="button"
        >
          <v-tab-pane label="基础通信 Topic" value="1">
            <Base :productKey="productKey"></Base>
          </v-tab-pane>
          <v-tab-pane label="物模型通信 Topic" value="2">
            <Physicalmodel :productKey="productKey"></Physicalmodel>
          </v-tab-pane>
          <v-tab-pane label="自定义 Topic" value="3">
            <Diy :productKey="productKey" :productId="productId"></Diy>
          </v-tab-pane>
        </v-tabs>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Base from "./topic-list/message-topic-base.vue";
import Diy from "./topic-list/message-topic-diy.vue";
import Physicalmodel from "./topic-list/message-topic-physicalmodel.vue";

export default {
  components: { Base, Diy, Physicalmodel },
  props: {
    productName:{},
    productId:{},
    productKey:{},
  },
  data() {
    return {
      activeNamebutton: "",
      searchData: "",
      placeholder: "请输入 Topic",
    };
  },
  created() {},

  methods: {
    showAdd() {},
    searchdata() {},
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
</style>
